import { render } from "./Faq.vue?vue&type=template&id=64d47bca&scoped=true&ts=true"
import script from "./Faq.vue?vue&type=script&lang=ts"
export * from "./Faq.vue?vue&type=script&lang=ts"

import "./Faq.vue?vue&type=style&index=0&id=64d47bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d47bca"]])

export default __exports__